export const isiOS = () => {
  if (!navigator) {
    return false;
  }
  const ua = navigator?.userAgent || '';
  return /iPad|iPhone|iPod/.test(ua);
};



// WEBPACK FOOTER //
// ./src/utils/getOs.js